import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Typography,
} from 'antd';
import { useSelector } from 'react-redux';
import ModalChangeFiscalPeriod from 'components/Layout/ModalChangeFiscalPeriod';
import { seelectEntidad } from 'store/auth';
import { toMoment } from 'utils/normalizers';

const { Text } = Typography;
const Footer = ({ editable }) => {
  const entidad = useSelector(seelectEntidad);

  return (
    <Col
      xs={0}
      sm={0}
      md={24}
      className="footer"
    >
      <Row
        align="bottom"
        justify="space-around"
      >
        <Text>
          <ModalChangeFiscalPeriod editable={editable} />
        </Text>
        <Text>
          Entidad:
          {' '}
          {entidad?.razon_social}
        </Text>
        <Text>
          Fecha:
          {' '}
          {toMoment(new Date()).format()}
        </Text>
      </Row>
    </Col>
  );
};

Footer.propTypes = {
  editable: PropTypes.bool,
};

Footer.defaultProps = {
  editable: true,
};

export default Footer;
